import { render, staticRenderFns } from "./PluggyConnect.vue?vue&type=template&id=afc15050&scoped=true&"
import script from "./PluggyConnect.vue?vue&type=script&lang=js&"
export * from "./PluggyConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc15050",
  null
  
)

export default component.exports